<template>
  <nav class="topic-navigation">
    <router-link
      :to="{ name: 'topic', params: { topicSlug: topic.slug } }"
      :class="{
        'topic-navigation__topic--active': topic.active,
        'book-subnavigation__item--mobile': mobile,
        'topic-navigation__topic--no-numbering': !$flavor.showTopicNavigationNumbering,
      }"
      tag="div"
      active-class="book-subnavigation__item--active"
      class="topic-navigation__topic book-subnavigation__item"
      v-for="topic in topics"
      :key="topic.id"
      @click="closeSidebar('navigation')"
    >
      {{ topic.title }}
    </router-link>
  </nav>
</template>

<script setup lang="ts">
import { graphql } from '@/__generated__';
import { useQuery } from '@vue/apollo-composable';
import { computed } from 'vue';
import { useSidebar } from '@/mixins/sidebar';

export interface Props {
  mobile: boolean;
}

const { closeSidebar } = useSidebar();

const { result } = useQuery(
  graphql(`
    query TopicsQuery {
      topics {
        id
        order
        title
        slug
      }
    }
  `)
);

const topics = computed(() => {
  return result.value?.topics || [];
});

withDefaults(defineProps<Props>(), {
  mobile: false,
});
</script>

<style scoped lang="scss">
@import 'styles/helpers';
// css counters: "https://www.freecodecamp.org/news/numbering-with-css-counters/"

.topic-navigation {
  display: flex;
  flex-direction: column;
  counter-reset: css-counter 0;

  &__topic {
    counter-increment: css-counter 1;

    &:before {
      content: counter(css-counter) '. ';
    }

    &--no-numbering:before {
      content: '';
    }
  }
}
</style>
